export const environment = {
    production:true,
    apiUrl:'https://api.lth.co.in/',
    finkupUrl:'https://dev.lth.co.in/',
    origin:'https://tickets.lth.co.in',
    baseDaomain:'lth.co.in',
    subDomain:'tickets',
    // origin:'http://localhost:4303',
    // baseDaomain:'localhost',
    // subDomain:'localhost',
    paymentUrl:'https://pay.lth.co.in/payment',
    paymentHost:'pay.lth.co.in',
    port:4303,
    isSeoRequired:false,
    finkupBaseURl : 'https://finkup-prod.s3.ap-south-1.amazonaws.com/static/services',
    razorpayKey: 'rzp_test_trGwC8EsfHSKXn',
};
